import React from 'react';
import lucienPhoto from '../../assets/lucien-koto.jpg';
import './Equipe.css';

const COMPETENCES = [
  'Data Science & IA',
  'Développement Full Stack',
  'Digitalisation',
  'Énergie Solaire',
  'Formation & Consulting',
  'Forage &  - Usines de traitement Eau Potable',  
  'Intstallation Machine Pure water et maintenance', 
  'Installation Pompe à eau',
  'Installation Panneaux solaires et maintenance',
];

const POSTES_OUVERTS = [
  {
    role: 'Data Scientiste Junior',
    stack: 'Python · Machine Learning · Tableaux de bord',
  },
  {
    role: 'Développeur Full Stack',
    stack: 'React · Node.js · Firebase',
  },
  {
    role: 'Commercial / Business Developer',
    stack: 'Prospection · CRM · Partenariats',
  },
];

// Dans src/components/sections/Equipe.jsx
export function addMembreEquipe  () { 
return (
    <div className="add-membre">
      {/* Formulaire pour ajouter un nouveau membre de l'équipe */}
      <p className="add-membre__label">Ajouter un nouveau membre de l'équipe (à implémenter)</p>
      <h2 className="add-membre__name">Nom du membre</h2>
      <p className="add-membre__role">Rôle du membre</p>
    </div>
  );
 };
 
export function updateMembreEquipe  () { 
  return (
    <div className="update-membre">
      {/* Formulaire pour mettre à jour un membre de l'équipe */}
      <p className="update-membre__label">Mettre à jour un membre de l'équipe (à implémenter)</p>
      <h2 className="update-membre__name">Nom du membre</h2>
      <p className="update-membre__role">Rôle du membre</p>
    </div>
  );
 };
export function removeMembreEquipe  () { 
  return (
    <div className="remove-membre">
      {/* Formulaire pour supprimer un membre de l'équipe */}
      <p className="remove-membre__label">Supprimer un membre de l'équipe (à implémenter)</p>
      <h2 className="remove-membre__name">Nom du membre</h2>
      <p className="remove-membre__role">Rôle du membre</p>
    </div>
  );
};

export function MembreEditor() { 
  return (
    <div className="membre-editor">
      {/* Formulaire pour éditer un membre de l'équipe */}
      <p className="membre__label">Éditeur de membre de l'équipe (à implémenter)</p>
      <h2 className="membre__name">Nom du membre</h2>
      <p className="membre__role">Rôle du membre</p>
      <ul className="membre__skills"></ul>
        <li>Compétence 1</li>
        <li>Compétence 2</li>

    </div>
  );
}
 
export default function Equipe() {
  return (
    <section className="equipe" id="equipe">
      <div className="equipe__intro">
        <p className="equipe__kicker">Notre équipe</p>
        <h2 className="equipe__title">Les personnes derrière KotosTechnology</h2>
        <p className="equipe__lead">
          Une petite équipe, un objectif clair&nbsp;: livrer des solutions
          data, web et énergie fiables — et grandir avec vous.
        </p>
      </div>

      <div className="equipe__profile">
        <div className="equipe__photo-wrap">
          <img
            className="equipe__photo"
            src={lucienPhoto}
            alt="Pasteur Lucien KOTO CHRISTOPHE, fondateur de KotosTechnology"
          />
        </div>

        <div className="equipe__card">
          <div className="equipe__id">
            <h3 className="equipe__name">Pasteur Lucien KOTO CHRISTOPHE</h3>
            <p className="equipe__role">
              Fondateur · Data Scientiste &amp; Développeur Full Stack
            </p>
          </div>

          <ul className="equipe__skills">
            {COMPETENCES.map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>

          <div className="equipe__contact">
            <a
              className="equipe__contact-link"
              href="https://wa.me/2290190111093"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp
            </a>
            <a
              className="equipe__contact-link"
              href="https://linkedin.com/in/lucien-koto-christophe-70a0bb350"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
            <a
              className="equipe__contact-link"
              href="mailto:innovation@kotostechnology.com"
            >
              Email
            </a>
          </div>
        </div>
      </div>

      <div className="equipe__openings">
        <p className="equipe__openings-label">Postes en recrutement</p>
        <div className="equipe__openings-grid">
          {POSTES_OUVERTS.map((poste) => (
            <div className="equipe__opening" key={poste.role}>
              <div className="equipe__opening-top">
                <span className="equipe__opening-role">{poste.role}</span>
                <span className="equipe__opening-status">
                  <span className="equipe__opening-dot" />
                  Ouvert
                </span>
              </div>
              <p className="equipe__opening-stack">{poste.stack}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
